export const brandItems = [
    {
        label: "Boss",
        href: "/brands/boss",
        logo: "/images/logos/boss-white.svg",
    },
    {
        label: "Howard Leight",
        href: "/brands/howard-leight",
        logo: "/images/logos/howard-leight-white.svg",
        hidden: true,
    },
    {
        label: "PIP Pro Safety",
        href: "/brands/prosafety",
        logo: "/images/logos/prosafety-white.svg",
    },
    {
        label: "North",
        href: "/brands/north",
        logo: "/images/logos/north-white.svg",
        hidden: true,
    },
    {
        label: "Miller",
        href: "/brands/miller",
        logo: "/images/logos/miller-white.svg",
        hidden: true,
    },
    {
        label: "Uvex",
        href: "/brands/uvex",
        logo: "/images/logos/uvex-white.svg",
        hidden: true,
    },
    {
        label: "Puma",
        href: "/brands/puma",
        logo: "/images/logos/puma-white.svg",
        hidden: true,
    },
    {
        label: "Hearos",
        href: "/brands/hearos",
        logo: "/images/logos/hearos-white.svg",
    },
    {
        label: "West County Gardener",
        href: "/brands/westcountygardener",
        logo: "/images/logos/wcg-white.svg",
    },
    {
        label: "Safety Works",
        href: "/brands/safetyworks",
        logo: "/images/logos/safety-works-white.svg",
    },
    {
        label: "Mud",
        href: "/brands/mud",
        logo: "/images/logos/mud-white.svg",
    },
];

export const desktopMenuLinks = [
    {
        label: "Company",
        href: "/company",
        children: [],
    },
    {
        label: "Brands",
        href: "#",
        type: "brands",
        children: brandItems,
    },
    {
        label: "Sales Tools",
        href: "#",
        children: [
            { label: "Learning Center", href: "/sales-tools/learning" },
            { label: "Literature", href: "/sales-tools/literature" },
            { label: "Videos", href: "/sales-tools/videos" },
        ],
    },
];

export function visibleMenuItems(items = []) {
    return items
        .filter((item) => !item.hidden)
        .map((item) =>
            item.children
                ? { ...item, children: visibleMenuItems(item.children) }
                : item
        );
}
